import React, { useEffect, useState, useRef } from "react";
import { useHistory, Link, Route } from "react-router-dom";
import { observer } from "mobx-react-lite";
import qs from "qs";
import classNames from 'classnames';
import { Layout, Navmenu, Loading } from "@jdcfe/legao";
import { AclRoutes } from "routes";
import useStores from "stores";
import VopHeader from "components/vop_header";
import AppHeader from "components/AppHeader";
import Breadcrumb from "components/Breadcrumb";
import CreateAppStepOne from "components/CreateAppStepOne";
import menuData from "./menu";
import CreateAppInput from "./../../components/CreateAppInput";
import { queryCreateApp } from "utils/api";
import { Dialog, Message } from "@jdcfe/legao";
// import logo from 'src/logo.svg';

import "./style.scss";

const { Container, Content, Header, Main } = Layout;

const FrameLayout = observer(({ route, location }) => {
  const { frameStore, loginStore } = useStores();
  const history = useHistory();
  const [createLoading, setCreateLoading] = useState(false);
  const containerRef = useRef(null);

  const [selectedKey, setSelectedKey] = useState('');

  useEffect(() => {
    console.log("-------------------frame init--------------------");

    async function init() {
      const query = qs.parse(location.search, { ignoreQueryPrefix: true });
      let appKey = query.appKey;

      frameStore.startFrameLoading();
      await frameStore.loadApps();
      frameStore.endFrameLoading();

      const firstAppKey = frameStore.apps[0] ? frameStore.apps[0].appKey : "";
      frameStore.changeApp(appKey || firstAppKey);
      if (location.pathname === '/app/frame'
        || !appKey
        || !frameStore.hasApp(appKey)) {
        history.push(`/app/frame/overview?appKey=${frameStore.currentAppKey}`);
      }
    }

    init();
  }, []);

  useEffect(() => {
    document.title = '京东VOP开放平台-管理控制台';

    document.addEventListener('click', () => {
      frameStore.hideAppList();
    })
  }, []);

  useEffect(() => {
    document.title = '京东VOP开放平台-管理控制台';
 
  },[]);

  useEffect(() => {
    setSelectedKey(location.pathname.indexOf('scheme')>-1?'/app/frame/scheme':location.pathname)
  },[location.pathname]);


  function handleMenuChange(key) {
    history.push(`${key}?appKey=${frameStore.currentAppKey}`);
  }

  
  function renderNode(menuData, level) {
    if(menuData.key === '/app/frame/overview') {
      return <h3 className={`lg-l${level}-title`} clstag="pageclick|keycount|VopOpenConsole_1611892618710|1">
                <a href="#!" className="is-block">
                  <span className="lg-navmenu-text">{menuData.title}</span>
                </a>
              </h3>
    } else if(menuData.key === '/app/frame/trafficpermission'){
      return <h3 className={`lg-l${level}-title`} clstag="pageclick|keycount|VopOpenConsole_1611892618710|11">
        <a href="#!" className="is-block">
          <span className="lg-navmenu-text">{menuData.title}</span>
        </a>
      </h3>
    } else if(menuData.key === '/app/frame/logmonitor'){
      return <h3 className={`lg-l${level}-title`} clstag="pageclick|keycount|VopOpenConsole_1611892618710|15">
        <a href="#!" className="is-block">
          <span className="lg-navmenu-text">{menuData.title}</span>
        </a>
      </h3>
    } else {
      return <h3 className={`lg-l${level}-title`} >
              <a href="#!" className="is-block">
                <span className="lg-navmenu-text">{menuData.title}</span>
              </a>
            </h3>
    }
  }

  function handleToggleAppList(e) {
    frameStore.toggleAppList();
    e.nativeEvent.stopImmediatePropagation();
  }

  function handleChangeApp(newAppKey) {
    frameStore.toggleAppList();
    
    const changed = frameStore.changeApp(newAppKey);
    // changed && history.push(`/app/frame/overview?appKey=${newAppKey}`);
    if (changed) {
      window.location.href = `/app/frame/overview?appKey=${newAppKey}`;
    }
  }
  function sureClick (createapp){
    const appName = document.querySelector(".appName .lg-input-o").value;
    const authCallbackUrl = document.querySelector(
      ".authCallbackUrl .lg-input-o"
    ).value;
    const developerPhone = document.querySelector(".developerPhone .lg-input-o")
      .value;
    const developerEmail = document.querySelector(".developerEmail .lg-input-o")
      .value;
    if (createLoading) {
      Message.showMsg({
        showIcon: true,
        type: "warn",
        description: "请稍等再试",
        autohide: true,
        closable: false,
        duration: 3000,
      });
      return;
    }
    setCreateLoading(true);
    queryCreateApp({
      appName,
      authCallbackUrl,
      developerPhone,
      developerEmail,
    }).then((res) => {
      if (document.querySelector(".input_item.error")) document.querySelector(".input_item.error").classList.remove("error");
      if (!res.data.success) {
        if (res.data.resultCode === "30000005") {
          document
            .querySelector(".appName")
            .parentNode.setAttribute("class", "input_item error");
          document.querySelector(".appName").nextSibling.innerHTML = res.data.resultMessage;
        } else if (res.data.resultCode === "30000006") {
          document
            .querySelector(".authCallbackUrl")
            .parentNode.setAttribute("class", "input_item error");
          document.querySelector(".authCallbackUrl").nextSibling.innerHTML = res.data.resultMessage;
        } else if (res.data.resultCode === "30000007") {
          document
            .querySelector(".developerEmail")
            .parentNode.setAttribute("class", "input_item error");
          document.querySelector(".developerEmail").nextSibling.innerHTML = res.data.resultMessage;
        } else if (res.data.resultCode === "30000008") {
          document
            .querySelector(".developerPhone")
            .parentNode.setAttribute("class", "input_item error");
          document.querySelector(".developerPhone").nextSibling.innerHTML = res.data.resultMessage;
        }else{
          Message.showMsg({
            showIcon: true,
            type: "wrong",
            description:res.data.resultMessage,
            autohide: true,
            closable: false,
            duration: 1000,
          });
        }
      } else {
        Message.showMsg({
          showIcon: true,
          type: "success",
          description: "创建成功",
          autohide: true,
          closable: false,
          duration: 1000,
        });
        setTimeout(() => {
          overviewStore.getApplist().then(() => {
            createapp.close();
          });
        }, 1000);
      }
      setCreateLoading(false);
    });
  }
  function handleCreate(){
    console.log("ssssss")
    
      const createapp = Dialog.confirm({
        title: "创建应用",
        children: <CreateAppInput></CreateAppInput>,
        wrapStyle: {
          zIndex: 99,
        },
        actions: [
          {
            text: "提交",
            onClick: () => {
              sureClick(createapp);
            },
            className: "sure",
            styleType: "primary",
            autoClose: false,
          },
          {
            text: "取消",
            onClick: () => createapp.close(),
            className: "cancel",
            styleType: "",
          },
        ],
        className: "create_dialog",
      });
  }
  function strSub(str){
    if(str.length > 8){
      return str.substring(0,8)+'...'
    }

    return str
  }
  
  let contentNode;
  if (!frameStore.loaded) {
    contentNode = null;
  } else if (frameStore.apps.length > 0) {
    contentNode = <AclRoutes watchQuery routes={route.routes} authorities={loginStore.authorities} />;
  } else {
    contentNode = <Route component={CreateAppStepOne} />;
  }

  return (
    <div className="frame">
      <Layout className="lg-layout-row">
        <Header>
          <VopHeader contentWidth="calc(100% - 28px)">
            <AppHeader></AppHeader>
          </VopHeader>
        </Header>
        <Main>
          <Container>
            <div className="frame-sider">
              <div className="apps">
                <div 
                  className={classNames("selected-app app", {
                    empty: !frameStore.apps || frameStore.apps.length <= 0
                  })} 
                  onClick={handleToggleAppList}
                  clstag="pageclick|keycount|VopOpenConsole_1611892618710|18"
                >
                  <div className="circle">{frameStore.firstChar}</div>
                  <div className="name" title={frameStore.currentAppName}>{strSub(frameStore.currentAppName)}</div>
                  
                  {
                    frameStore.totalCount > 0 && (
                      <div className="exchange">
                        {/* <img
                          className="dropdown"
                          alt="dropdown"
                          src="https://img14.360buyimg.com/imagetools/jfs/t1/151245/8/7016/615/5fb2393bE716e464d/9ed31e4259405330.png"
                        /> */}
                        <span className="dropdown"></span>
                        <p>切换</p>
                      </div> 
                    )
                  }
                  
                </div>
                {
                  <div
                    className="app-list"
                    style={{
                      display: frameStore.showAppList ? "block" : "none",
                    }}
                  >
                    <div className="total">
                      <span>{`全部应用（${frameStore.totalCount}）`}</span>
                      <Link
                        className="view-all"
                        to="/app/basic/list"
                        onClick={() => frameStore.toggleAppList()}
                        clstag="pageclick|keycount|VopOpenConsole_1611892618710|19"
                      >
                        应用详情
                      </Link>
                      <span  className="view-all" onClick={(e)=>{e.stopPropagation();handleCreate()}} clstag="pageclick|keycount|VopOpenConsole_1611892618710|20">
                      <svg t="1631867420817" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2641" width="14" height="14"><path d="M675.04 483.264l-127.04 0 0-127.264c0-20.064-16.288-36.32-36.32-36.32-20.064 0-36.32 16.192-36.32 36.32l0 127.232-127.072 0c-20.064 0-36.352 16.32-36.352 36.352 0 20.064 16.224 36.352 36.352 36.352l127.072 0 0 127.232c0 20 16.256 36.384 36.32 36.384 20.032 0 36.32-16.256 36.32-36.384l0-127.136 127.04 0c19.968 0 36.352-16.256 36.352-36.384C711.36 499.552 695.136 483.264 675.04 483.264L675.04 483.264zM511.328 65.44c-250.24 0-453.952 203.616-453.952 453.952 0 250.336 203.712 453.952 453.952 453.952 250.336 0 453.984-203.584 453.984-453.952C965.312 269.056 761.696 65.44 511.328 65.44L511.328 65.44zM511.328 916.576c-219.04 0-397.184-178.176-397.184-397.152 0-219.104 178.144-397.216 397.184-397.216s397.216 178.112 397.216 397.216C908.576 738.368 730.368 916.576 511.328 916.576L511.328 916.576zM511.328 916.576" p-id="2642" fill="#0083ff"></path></svg>
                         新建应用</span>
                    </div>
                    {frameStore.apps.map((item) => (
                      <div
                        className="app-item app"
                        key={item.appKey}
                        onClick={() => handleChangeApp(item.appKey)}
                      >
                        <div className="circle">
                          {item.appName.substr(0, 1)}
                        </div>
                        <div className="name" title={item.appName}>{item.appName}</div>
                        {frameStore.currentAppKey &&
                        frameStore.currentAppKey === item.appKey ? (
                          <img
                            className="check"
                            src="https://img10.360buyimg.com/imagetools/jfs/t1/140292/18/13227/484/5fa25bd0E57884d8a/8718a6c2d55bf22c.png"
                            alt=""
                          />
                        ) : null}
                      </div>
                    ))}
                  </div>
                }
              </div>
          
              <Navmenu
                ref={containerRef}
                data={menuData}
                defaultSelectedKey={selectedKey}
                defaultOpenKeys={["1"]}
                color="light"
                hasMini={false}
                navItem={renderNode}
                onChangeSelect={handleMenuChange}
              />
            </div>
            <Content className="lg-layout-inner frame-content">
              <div className="frame-content-wrapper">
                <div className="frame-breadcrumb">
                  <Breadcrumb path={location.pathname} />
                </div>
                <div className="frame-content-inner">
                  {contentNode}
                </div>
                {
                  frameStore.pageLoading && (
                    <div className="page-loading">
                      <Loading />
                    </div>
                  )
                }
              </div>
            </Content>
          </Container>
        </Main>
        {frameStore.frameLoading && (
          <div className="frame-loading">
            <Loading />
          </div>
        )}
      </Layout>
    </div>
  );
});
// };

export default FrameLayout;
